import React from 'react';
import { Helmet } from 'react-helmet';
import { checkWithinSeCe } from 'components/ProtectedRoute/utils';

const ThirdPartyScripts = () => {
  if (checkWithinSeCe()) return null; // NEVER load 3rd party scripts within SeCe.

  return (
    <>
      {/* Adobe Analytics */}
      <Helmet>
        <script
          src={
            process.env.REACT_APP_AA_LAUNCH_SCRIPT_URL ||
            'https://static-staging.veeqo.com/cc/aa/dev.min.js'
          }
          type="text/javascript"
          id="aa-launch-script"
          data-testid="adobe-analytics-script"
        />
      </Helmet>
    </>
  );
};

export default ThirdPartyScripts;
